<template>
  <div>
    <div class="sticky-top">
      <BaseLogoBar />
      <BaseNavbar />
      <div v-if="user === null">
        <BreadCrumb />
      </div>
    </div>
    <div class="d-flex" id="wrapper">
      <div id="page-content-wrapper" class="">
        <div class="">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <BaseFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BreadCrumb from './components/ngo-breadcrumbs.vue';

export default {
  name: 'ngo-index',
  components: {
    BreadCrumb,
  },

  computed: {
    ...mapGetters('auth', ['user']),
  },
};
</script>

<style scoped>
#wrapper {
  overflow-x: hidden;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
.sticky-top {
  /* background-color: white;
  margin-top: 10rem; */
}
</style>
